import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontWeights, Stack, Text } from '@fluentui/react';
//TODO: move to `/layout` and merge with RP's PageHeader component suite.
/**
 * A prestyled header to make all of MSRC's forms look and feel the same.
 */
export const Header = ({ inCard = false, title, subtitle, headerId, titleAs = 'h2', }) => {
    if (inCard) {
        return (_jsxs(Stack, { children: [_jsx(Text, Object.assign({ id: headerId, variant: 'mediumPlus', styles: { root: { fontWeight: FontWeights.semibold, margin: 0 } }, as: titleAs }, { children: title })), _jsx(Text, { children: subtitle })] }));
    }
    return (_jsx("div", Object.assign({ style: { width: '100%', maxWidth: '800px' } }, { children: _jsxs(Stack, Object.assign({ tokens: { childrenGap: 4, maxWidth: '580px' }, horizontalAlign: 'start' }, { children: [_jsx(Text, Object.assign({ id: headerId, variant: 'xLarge', styles: { root: { fontWeight: FontWeights.semibold, margin: 0 } }, as: titleAs }, { children: title })), subtitle && _jsx(Text, { children: subtitle })] })) })));
};
